<template>

  <div>
    <div class="text-muted mb-3">Adicionar cartão de crédito</div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label>Primeiro nome</label>
          <input
            class="form-control"
            type="text"
            placeholder="Primeiro nome"
            v-model="credcard.first_name">
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label>Sobrenome</label>
          <input
            class="form-control"
            type="text"
            placeholder="Sobrenome"
            v-model="credcard.last_name">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label>Número do cartão de crédito</label>
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              maxlength="16"
              placeholder="0000000000000000"
              v-model="credcard.number" />
            <div
              v-if="brand"
              class="input-group-append">
              <span
                class="input-group-text"
                id="basic-addon2">{{ brand }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-4">
        <label>Mês</label>
        <input
          class="form-control"
          type="text"
          maxlength="2"
          placeholder="07"
          v-model="credcard.month" />
      </div>
      <div class="form-group col-sm-4">
        <label>Ano</label>
        <input
          class="form-control"
          type="text"
          maxlength="4"
          :placeholder="placeholderYear"
          v-model="credcard.year" />
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label>CVV/CVC</label>
          <input
            class="form-control"
            v-model="credcard.cvv"
            type="text"
            maxlength="4"
            placeholder="123">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-6">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="credcard_default"
            v-model="credcard.default">
          <label
            class="form-check-label"
            for="credcard_default">Tornar padrão</label>
        </div>
      </div>
    </div>

    <div
      v-if="invalidCredcard"
      class="alert alert-danger mb-3">
      Dados de cartão de crédido inválidos.
    </div>

    <div
      :class="{'box-loading': loading}">
      <button
        class="btn btn-primary"
        @click="createCredCard">
        {{ $t('Add') }}
        </button>
      <button
        v-if="showCancel"
        class="btn btn-outline-secondary"
        @click="cancel">
        {{ $t('Cancel') }}
        </button>
    </div>
  </div>

</template>

<script>
import moment from 'moment'
export default {
  name: 'BillingCredcardNew',
  props: {
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  data () {
    const credcard = process.env.NODE_ENV === 'production' ? {
      default: true
    } : {
      number: '4111111111111111',
      month: '04',
      year: '2024',
      first_name: 'William',
      last_name: 'Coelho',
      cvv: '008',
      default: true
    }

    return {
      loading: false,
      iugu: window.Iugu,
      credcard: credcard,
      invalidCredcard: false
    }
  },
  computed: {
    brand () {
      if (!this.credcard.number) return null
      return this.iugu.utils.getBrandByCreditCardNumber(this.credcard.number)
    },
    placeholderYear () {
      return moment().add(5, 'year').year()
    }
  },
  created () {
    this.iugu.setAccountID('E6C1AC9B8E1A4FEFA4B294B2FF3BFC02')
    this.iugu.setTestMode(process.env.NODE_ENV !== 'production')
  },
  methods: {
    reset () {
      this.credcard = {
        number: '',
        month: '',
        year: '',
        first_name: '',
        last_name: '',
        cvv: '',
        default: true
      }
    },
    createCredCard () {
      const cc = this.iugu.CreditCard(
        this.credcard.number,
        this.credcard.month,
        this.credcard.year,
        this.credcard.first_name,
        this.credcard.last_name,
        this.credcard.cvv
      )
      if (!cc.valid()) {
        this.invalidCredcard = true
      } else {
        this.invalidCredcard = false

        this.loading = true
        this.iugu.createPaymentToken(cc, (response) => {
          this.loading = false
          if (response.errors) {
            if (response.errors.record_invalid === 'Validation failed: Number is invalid') {
              this.invalidCredcard = true
            } else {
              console.log(response)
            }
          } else {
            this.reset()
            this.$emit('save', {
              description: 'Credcard',
              token: response.id,
              set_as_default: this.credcard.default
            })
          }
        })
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingCredcardNew.vue